<template>
  <div>
    <h1>Terms and Conditions</h1>
    <p><strong>PrimeFusion Oy (Business ID: 3511657-2)</strong></p>

    <h2>1. Introduction</h2>
    <p>Welcome to PrimeFusion Oy ("Company," "we," "us," or "our"). These Terms and Conditions ("Terms") govern your access to and use of our websites, software products, and services (collectively, the "Services"). By using our Services, you agree to comply with these Terms. If you do not agree, please refrain from using our Services.</p>

    <h2>2. Acceptance of Terms</h2>
    <p>By accessing or using our Services, you acknowledge that you have read, understood, and agreed to be bound by these Terms. We reserve the right to update these Terms at any time, and continued use of the Services constitutes acceptance of any modifications.</p>

    <h2>3. Use of Services</h2>
    <ul>
      <li>You must be at least 18 years old to use our Services.</li>
      <li>You agree not to use our Services for any unlawful purposes.</li>
      <li>Unauthorized access, distribution, or modification of our Services is strictly prohibited.</li>
    </ul>

    <h2>4. Intellectual Property</h2>
    <p>All content, trademarks, and intellectual property within our Services are owned by PrimeFusion Oy. Unauthorized use, reproduction, or distribution of our intellectual property is prohibited.</p>

    <h2>5. Limitation of Liability</h2>
    <p>PrimeFusion Oy provides its Services "as is" and does not guarantee uninterrupted availability. We are not liable for any direct or indirect damages resulting from your use of our Services.</p>

    <h2>6. Termination</h2>
    <p>We reserve the right to terminate or suspend access to our Services at our sole discretion, without prior notice, for any violation of these Terms.</p>

    <h2>7. Governing Law</h2>
    <p>These Terms are governed by the laws of Finland. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of Finnish courts.</p>
  </div>
</template>
